import { useEffect, useState } from 'react';
import { hasExpeditionTrackData } from 'components/MapLibre/expeditionTrackLayers';

const EMPTY_TRACK = { type: 'FeatureCollection', features: [] };

const useExpeditionTrack = (projectId) => {
  const [expeditionTrackGeoJson, setExpeditionTrackGeoJson] = useState(EMPTY_TRACK);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!projectId) {
      setExpeditionTrackGeoJson(EMPTY_TRACK);
      setLoading(false);
      setError(null);
      return undefined;
    }

    setExpeditionTrackGeoJson(EMPTY_TRACK);

    let cancelled = false;
    const loadTrack = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `/api/public/projects/${projectId}/expedition-track.geojson`,
        );
        if (!response.ok) {
          throw new Error(`Failed to load expedition track (${response.status})`);
        }
        const data = await response.json();
        if (!cancelled) {
          setExpeditionTrackGeoJson(data);
        }
      } catch (err) {
        if (!cancelled) {
          setExpeditionTrackGeoJson(EMPTY_TRACK);
          setError(err);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadTrack();
    return () => {
      cancelled = true;
    };
  }, [projectId]);

  return {
    expeditionTrackGeoJson,
    hasExpeditionTrack: hasExpeditionTrackData(expeditionTrackGeoJson),
    loading,
    error,
  };
};

export default useExpeditionTrack;
